import { PlusIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs/tabs";
// import { Label } from "@/components/ui/label/label";
// import {
//   RadioGroup,
//   RadioGroupItem,
// } from "@/components/ui/radio-group/radio-group";

// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover/popover";
import { Button } from "@/components/ui/button/button";
import {
  getAllLeaveApplicationOfCurrentEmployeeQueryOptions,
  getAllLeaveApplicationOfOtherEmployeesAsApproverQueryOptions,
} from "@/config/queries/emp-query-options";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/leave-application-table/data-table";
import { columns } from "./_components/leave-application-table/columns";
import { DataTable as OthersDataTable } from "./_components/others-leave-applications/others-leave-application-table/data-table";
import { columns as OthersColumns } from "./_components/others-leave-applications/others-leave-application-table/columns";

import { CancelLeaveRequestModal } from "./_components/cancel-leave-request-modal/cancel-request-modal";

import { useAuth } from "@/lib/use-auth";
// import { useStatusFilter } from "./hooks/use-status-filter";
// import { Separator } from "@/components/ui/separator/separator";
import { ViewLeaveApplicationOfOthersModal } from "./_components/others-leave-applications/view-leave-application-modal/view-leave-application-modal";
import { TakeActionOnOthersLeaveApplicationModal } from "./_components/others-leave-applications/take-action-modal/take-action-modal";

const EmployeeLeaveApplications = () => {
  // const { filter, setFilter } = useStatusFilter();
  // @ts-nocheck
  // @ts-ignore
  const [tabValue, setTabValue] = useState("my-leave-applications");

  const employeeKey = Cookies.get("key") as string;
  const { data: authData } = useAuth();

  const {
    data: allOtherLeavesData,
    isPending: isOtherLeavesPending,
    isFetching: isOtherLeavesFetching,
  } = useQuery(
    getAllLeaveApplicationOfOtherEmployeesAsApproverQueryOptions(
      employeeKey,
      authData?.user?.permissions?.["1"]?.includes("LeaveApplication")
      // filter
    )
  );

  const othersLeaves = useMemo(() => {
    if (isOtherLeavesPending) {
      return [];
    }

    if (
      allOtherLeavesData === undefined ||
      allOtherLeavesData?.LeaveApplication === undefined
    ) {
      return [];
    }

    const result = allOtherLeavesData?.LeaveApplication?.map((la) => {
      return {
        id: la?._id,
        leaveType: la?.leaveType,
        reason: la?.reason,
        startDate: la?.startDate,
        endDate: la?.endDate,
        status: la?.status,
        employeeName: la?.employee?.name,
        employeeEmail: la?.employee?.email,
        createdAt: la?.createdAt,
        attachment: la?.attachment,
        isPaid: la?.isPaid,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isOtherLeavesPending, isOtherLeavesFetching, allOtherLeavesData]);

  const { data, isPending, isFetching } = useQuery(
    getAllLeaveApplicationOfCurrentEmployeeQueryOptions(employeeKey)
  );

  const leaveApplicationData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.LeaveApplication === undefined) {
      return [];
    }

    const result = data?.LeaveApplication?.map((la) => {
      return {
        id: la?._id,
        leaveType: la?.leaveType,
        reason: la?.reason,
        startDate: la?.startDate,
        endDate: la?.endDate,
        status: la?.status,
        employeeName: la?.employee?.name,
        employeeEmail: la?.employee?.email,
        createdAt: la?.createdAt,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isPending, isFetching, data]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-lg md:text-2xl font-medium">Leave Applications</h3>

        <Button className="flex items-center gap-1 h-7 md:h-9" asChild>
          <Link to="/employee/leave-applications/new">
            <PlusIcon className="hidden sm:block" />
            <span>Add Leave Application</span>
          </Link>
        </Button>
      </div>

      <div className="mt-3">
        <Tabs defaultValue="my-leave-applications" className="w-full">
          <div className="flex items-center justify-between">
            <TabsList>
              <TabsTrigger
                value="my-leave-applications"
                onClick={() => setTabValue("my-leave-applications")}
              >
                My Leave Applications
              </TabsTrigger>
              {authData?.user?.permissions?.["1"]?.includes(
                "LeaveApplication"
              ) && (
                <TabsTrigger
                  value="other-leave-applications"
                  onClick={() => setTabValue("other-leave-applications")}
                >
                  Other's Leave Applications
                </TabsTrigger>
              )}
            </TabsList>

            {/* {tabValue === "other-leave-applications" && (
              <Popover>
                <PopoverTrigger>
                  <Button
                    className="mr-3 flex items-center gap-2"
                    size="sm"
                    variant="outline"
                  >
                    <DoubleArrowDownIcon className="w-4 h-4" />
                    Filter
                    {filter && (
                      <>
                        <Separator orientation="vertical" />
                        {filter} ({othersLeaves?.length})
                      </>
                    )}
                  </Button>
                </PopoverTrigger>
                <PopoverContent>
                  <RadioGroup
                    value={filter}
                    onValueChange={(
                      value: "Pending" | "Approved" | "Rejected" | "Cancelled"
                    ) => {
                      setFilter(value);
                    }}
                  >
                    <div className="flex items-center space-x-2 cursor-pointer w-fit">
                      <RadioGroupItem value="Pending" id="pending" />
                      <Label htmlFor="pending">Pending</Label>
                    </div>
                    <div className="flex items-center space-x-2 cursor-pointer w-fit">
                      <RadioGroupItem value="Approved" id="approved" />
                      <Label htmlFor="approved">Approved</Label>
                    </div>
                    <div className="flex items-center space-x-2 cursor-pointer w-fit">
                      <RadioGroupItem value="Rejected" id="rejected" />
                      <Label htmlFor="rejected">Rejected</Label>
                    </div>
                    <div className="flex items-center space-x-2 cursor-pointer w-fit">
                      <RadioGroupItem value="Cancelled" id="cancelled" />
                      <Label htmlFor="cancelled">Cancelled</Label>
                    </div>
                  </RadioGroup>
                </PopoverContent>
              </Popover>
            )} */}
          </div>
          <TabsContent value="my-leave-applications">
            {isPending ? (
              <div className="h-20 mt-10 flex items-center justify-center">
                <Spinner size="small">
                  <p>Searching for Leave Applications of yours...</p>
                </Spinner>
              </div>
            ) : data?.LeaveApplication?.length ? (
              <div className="mt-5">
                <DataTable data={leaveApplicationData} columns={columns} />
              </div>
            ) : (
              <div className="border h-20 flex items-center justify-center mt-5">
                No Leave Applications of yours.
              </div>
            )}
          </TabsContent>
          {authData?.user?.permissions?.["1"]?.includes("LeaveApplication") && (
            <TabsContent value="other-leave-applications">
              {isOtherLeavesPending ? (
                <div className="h-20 mt-10 flex items-center justify-center">
                  <Spinner size="small">
                    <p>Searching for Leave Applications of others...</p>
                  </Spinner>
                </div>
              ) : allOtherLeavesData?.LeaveApplication?.length ? (
                <div className="mt-5">
                  <OthersDataTable
                    data={othersLeaves}
                    columns={OthersColumns}
                  />
                </div>
              ) : (
                <div className="border h-20 flex items-center justify-center mt-5">
                  No Leave Applications of others.
                </div>
              )}
            </TabsContent>
          )}
        </Tabs>
      </div>

      <CancelLeaveRequestModal />

      <ViewLeaveApplicationOfOthersModal />
      <TakeActionOnOthersLeaveApplicationModal />
    </div>
  );
};

export default EmployeeLeaveApplications;
